import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const SystemPage = loadable(() => import('./SystemPage'));
export default {
    id: 'system',
    title: 'System',
    icon: 'ed-system',
    iconType: 'ed',
    route: 'system',
    defaultRoute: 'system/storage-management',
    component: SystemPage,
    group: 'setup',
    subGroup: 'general',
    order: 4,
    structure,
};
